"use client";

import { useContext } from "react";
import { usePathname } from "next/navigation";
import classNames from "classnames";

import { Wrapper } from "@/components/Wrapper";
import { Stepper } from "@/components/Stepper";
import { QRPreview } from "@/components/QRPreview";
import { QREditorFooter } from "@/components/QREditorFooter";

import { QREditorContext } from "@/contexts/QREditorContext";

import {
  QREditorLayoutTemplateProps,
  QREditorLayoutTemplateStepperButtonDataProps,
} from "./types";
import "./styles.scss";

export const initialStepperButtons = (
  stepperButtonsData: QREditorLayoutTemplateStepperButtonDataProps[]
) => {
  return stepperButtonsData.map((stepperButton) => {
    return {
      label: stepperButton.label,
      dataQA: stepperButton.dataQA,
      disabled: false,
    };
  });
};

export const QREditorLayoutTemplate = (props: QREditorLayoutTemplateProps) => {
  const pathname = usePathname();
  const qrEditorContext = useContext(QREditorContext);
  const isRegister = () => pathname?.includes("/register");

  const stepperButtons = initialStepperButtons(props.data.stepperButtons);
  const { customClass } = props.data;
  const classnames = classNames(`qr-editor-layout`, {
    [`${customClass}`]: customClass,
  });

  return (
    <div className={classnames}>
      {!isRegister() && (
        <div className="EditorLayout__stepper">
          <Stepper
            stepButtons={stepperButtons}
            isValidForm={qrEditorContext?.qrData?.isValidForm}
          />
        </div>
      )}
      <Wrapper customClass="EditorLayout__wrapper">
        <div className="EditorLayout__container">
          <div className="EditorLayout__form">{props.children}</div>
          <div className="EditorLayout__preview">
            <QRPreview
              previewTranslations={props.data.previewTranslations}
              previewHome={props.data.previewSelector}
              language={props.language}
              modalData={props.data.modalData}
            />
          </div>
        </div>
        {!isRegister() && <QREditorFooter data={props.data} />}
      </Wrapper>
    </div>
  );
};
